/**
 * 管理WEB应用缓存
 * @type {{
 * clearAll: sessionManager.clearAll,
 * clearItem: sessionManager.clearItem,
 * get: sessionManager.get,
 * set: sessionManager.set
 * }}
 */
const cookieManager = {
  set: function (key, val, time) { // 设置cookie方法
    const date = new Date(); // 获取当前时间
    const expiresDays = time; // 将date设置为n天以后的时间
    date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); // 格式化为cookie识别的时间
    document.cookie = `${key}=${val};expires=${date.toGMTString()}`; // 设置cookie
  },
  get: function (cname) { // 获取cookie方法
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(name) === 0) { return c.substring(name.length, c.length); }
    }
    return "";
  },
};

export { cookieManager };



// WEBPACK FOOTER //
// ./src/AntD/utils/cookieStorage.js